import { Tabs as MuiTabs, TabsProps } from '@mui/material';

const Tabs = (props: TabsProps): JSX.Element => <MuiTabs {...props} />;

export default Tabs;
